import reducer, { eventsTypes } from './duck';

export { Top } from './containers';

export const topModule = {
  reducer: reducer,
  eventsTypes: eventsTypes,
};
